import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { prepareRichTextContent } from "../utils/rich-text-content.util";

@Pipe({
  name: "cRichTextContent",
})
export class CRichTextContentPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string | null | undefined): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(prepareRichTextContent(value));
  }
}
